import * as React from 'react';
import Box from '@mui/material/Box';
// import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Session_page_body from './Body/Session/pageBody';
import Registed_page_body from './Body/Registed/pageBody';
import Registration_page_body from './Body/Registration/pageBody';
import Task_page_body from './Body/task/pageBody';
import Volanteering_page_body from './Body/Volanteering/pageBody';
import { createSelector } from '@reduxjs/toolkit';
import SignUp_page_body from './Body/SignUp/pageBody';
import Login_page_body from './Body/Login/pageBody';
import Home_page_body from './Body/Home/pageBody';
import CreateDbGroup from './Body/CreateDbGroup/pageBody';
import CreateDb from './Body/CreateDb/pageBody';
import DbBrowser from './Body/DbBrowser/pageBody';
import DbRecords from './Body/DbRecords/pageBody';
import EditDbGroup from './Body/EditDbGroup/pageBody';
import DbManagement from './Body/DbManagement/pageBody';
import Profile from './Body/Profile/pageBody';
import Chat from './Body/Chat/pageBody';
import Dashboard from './Common_Components/Dashboard/component.jsx';
import ChangeRequests from './Body/ChangeRequests/pageBody';
import YjsTestPage from './Yjs/YjsTestPage';
// import { volanteer_switch } from '../volanteer';
// import { createData } from './Common_Components/List_Table/list_table';
// import {get_all_recorded_rows} from '../db';
// import { createData } from './Common_Components/List_Table/list_table';



export default function AppBody(props) {
  const [value, setValue] = React.useState('1');
  // const [rows, setRows] = React.useState(window.all_registed_childrens.map((data) => createData(...[ data.Name, data.Class, data.Address ])));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const volanteering_page_state_selector = createSelector(
    (state) => state.volanteer.enabled
  )
  
  return (
    <Box sx={{ width: '100%', typography: 'body1', paddingBottom: '56px' }}>
      <TabContext value={props.page}>
        <TabPanel value="Login">
          <Login_page_body />
        </TabPanel>
        <TabPanel value="SignUp">
          <SignUp_page_body />
        </TabPanel>
        <TabPanel value="Home">
          <Home_page_body />
        </TabPanel>
        <TabPanel value="Session">
          <Session_page_body />
        </TabPanel>
        <TabPanel value="Registed">
          <Registed_page_body />
        </TabPanel>
        <TabPanel value="Registration">
          <Registration_page_body optional_editing={true} default_editing_option={""} initial_record={undefined}/>
        </TabPanel>
        <TabPanel value="Task">
          <Task_page_body optional_editing={true} default_editing_option={""} initial_record={undefined}/>
       </TabPanel>
        <TabPanel value="Volanteering">
          <Volanteering_page_body optional_editing={true} default_editing_option={""} initial_record={undefined} volanteer_switch={window.volanteer_switch.value}/>
       </TabPanel>
        <TabPanel value="CreateDbGroup">
          <CreateDbGroup />
        </TabPanel>
        <TabPanel value="CreateDb">
          <CreateDb />
        </TabPanel>
        <TabPanel value="DbBrowser">
          <DbBrowser />
        </TabPanel>
        <TabPanel value="DbRecords">
          <DbRecords />
        </TabPanel>
        <TabPanel value="EditDbGroup">
          <EditDbGroup />
        </TabPanel>
        <TabPanel value="DbManagement">
          <DbManagement />
        </TabPanel>
        <TabPanel value="Profile">
          <Profile />
        </TabPanel>
        <TabPanel value="Chat">
          <Chat />
        </TabPanel>
        <TabPanel value="ChangeRequests">
          <ChangeRequests />
        </TabPanel>
        <TabPanel value="Dashboard">
          <Dashboard />
        </TabPanel>
        <TabPanel value="YjsTest">
          <YjsTestPage />
        </TabPanel>
      </TabContext>
      {/* <CustomizedSnackbars/> */}
    </Box>
  );
}
